export function isValidEmail(email) {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
}

export function normalizeFrenchMobile(phone, countryCode = "+33") {
  if (!phone) return "";
  const clean = phone.replace(/[\s\-\(\)]/g, '');
  let fullNumber = clean;
  if (!clean.startsWith('+') && !clean.startsWith('00')) {
    if (clean.startsWith('0')) {
      fullNumber = countryCode + clean.slice(1);
    } else {
      fullNumber = countryCode + clean;
    }
  }
  if (fullNumber.startsWith('00')) {
    fullNumber = '+' + fullNumber.substring(2);
  }
  return fullNumber;
}

export function isValidFrenchMobile(phone, countryCode = "+33") {
  if (!phone) return false;
  const normalized = normalizeFrenchMobile(phone, countryCode);
  return /^\+33[67]\d{8}$/.test(normalized);
}

export function isValidIBAN(iban) {
  if (!iban) return false;
  const cleanIban = iban.replace(/\s+/g, '').toUpperCase();
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(cleanIban)) {
    return false;
  }
  const rearranged = cleanIban.slice(4) + cleanIban.slice(0, 4);
  const numeric = rearranged.split('').map(char => {
    const code = char.charCodeAt(0);
    if (code >= 65 && code <= 90) return (code - 55).toString();
    return char;
  }).join('');
  
  let checksum = numeric.slice(0, 2);
  let fragment;
  for (let offset = 2; offset < numeric.length; offset += 7) {
    fragment = String(checksum) + numeric.slice(offset, offset + 7);
    checksum = parseInt(fragment, 10) % 97;
  }
  return checksum === 1;
}
